import React from 'react';
import { Box, Table, Thead, Tbody, Tr, Th, Td } from '@chakra-ui/react';
import { format } from 'date-fns';

const GeneralReportTable = ({ data }) => {
  // Eğer data yoksa veya boşsa
  if (!data || data.length === 0) {
    return <Box>No data to display</Box>;
  }

  const formatDate = dateString => {
    try {
      const date = new Date(dateString); // Tarih stringini Date nesnesine çevirin
      return format(date, 'dd/MM/yyyy HH:mm:ss'); // İstenilen formatta tarihi döndür
    } catch (error) {
      console.warn(`Invalid date format for: ${dateString}`, error);
      return 'Invalid date';
    }
  };

  // Tablo başlıklarını dinamik olarak belirleme
  const headers = Object.keys(data[0]);

  return (
    <Box overflowX="auto">
      <Table variant="simple" colorScheme="gray">
        <Thead>
          <Tr>
            {headers.map((header, index) => (
              <Th key={index}>{header}</Th>
            ))}
          </Tr>
        </Thead>
        <Tbody>
          {data.map((row, rowIndex) => (
            <Tr key={rowIndex}>
              {headers.map((header, colIndex) => (
                <Td key={colIndex}>
                  {header === 'time'
                    ? formatDate(row[header]) // Sadece 'time' için formatDate kullan
                    : row[header]}
                </Td>
              ))}
            </Tr>
          ))}
        </Tbody>
      </Table>
    </Box>
  );
};

export default GeneralReportTable;
